module.exports = __webpack_public_path__ + "static/the-best-american-science-and-nature-writing-2013-76565f43b7c704f77a47d83e0eedbe81.jpg";